module.exports = __webpack_public_path__ + "img/48_22.ef6934b7.png";